// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/opt/build/repo/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-habit-streak-tsx": () => import("/opt/build/repo/src/pages/habit-streak.tsx" /* webpackChunkName: "component---src-pages-habit-streak-tsx" */),
  "component---src-pages-index-js": () => import("/opt/build/repo/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-stationery-tsx": () => import("/opt/build/repo/src/pages/stationery.tsx" /* webpackChunkName: "component---src-pages-stationery-tsx" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/opt/build/repo/.cache/data.json")

